import { FC } from 'react'
import { GetServerSideProps } from 'next'
import { Meta } from '../../../constants/meta'
import { PageContainer } from '../../../components/layout'
import { PrintStoreTemplates } from '@app/code/src/components/PrintStoreTemplates'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'
import printStoreProductMetaTags from '../../../constants/printStoreProductMetaTags'

export const getServerSideProps: GetServerSideProps<{ meta: Meta }> = async ({ params }) => {
  const productId = params?.productId as string

  return {
    props: {
      meta: printStoreProductMetaTags[productId] || {}
    }
  }
}

const PrintStoreProductTemplatesPage: FC<{ meta: Meta }> = ({ meta }) => {
  useRedirectOnAuthChanges()

  return (
    <PageContainer
      page={Routes.PRINT_STORE_PRODUCT_TEMPLATES}
      disableSideNav
      disableFooter
      injectedMeta={meta}
    >
      <PrintStoreTemplates />
    </PageContainer>
  )
}

export default PrintStoreProductTemplatesPage
